/* eslint-disable camelcase */

import {
  ContentPublisherTrackingProps,
  DynamicPageTrackingProps,
  PageTrackingProps,
  Publisher,
} from "@companion-core/shared/app/Interfaces/tracking";
import { trackPage, trackPublisher } from "@companion-core/shared/app/tracking/index";
import LevelsEnum from "@companion-core/shared/app/tracking/enums/levels";

export const trackDynamicPage = ({
  pageSlug,
  contentId,
  vendorId,
  family,
  subfamily,
}: DynamicPageTrackingProps) => {
  const trackDynamicPageOptions: PageTrackingProps = {
    page: pageSlug,
    page_chapter1: pageSlug,
    site_level2: LevelsEnum.Dynamic,
  };
  if (contentId && vendorId) {
    trackDynamicPageOptions.contentId = contentId;
    trackDynamicPageOptions.vendorId = vendorId;
  }
  if (family) trackDynamicPageOptions.page_chapter2 = `${family}|${subfamily ?? ""}`;
  return trackPage({ ...trackDynamicPageOptions });
};

export const trackContentPublisher = ({
  pageSlug,
  chapters,
  format = "",
  url = "",
  contentId = "",
  positionItem,
  nbItems,
  vendorId = "",
}: ContentPublisherTrackingProps): Publisher => {
  const generalPlacement =
    positionItem == null ? "" : nbItems ? `[${positionItem}-${nbItems}]` : `[${positionItem}]`;

  const chapter1 = chapters?.chapter1 ?? pageSlug;
  const chapter2 = chapters?.chapter2 ?? "";
  const chapter3 = chapters?.chapter3 ?? "";

  const payload: Publisher = {
    onsitead_campaign: `[${chapter1}::${chapter2}::${chapter3}::${pageSlug}]`,
    onsitead_creation: `[${url || "no_url"}]`,
    onsitead_variant: `[${contentId}]`,
    onsitead_format: `[${format}]`,
    onsitead_general_placement: generalPlacement,
    onsitead_advertiser: vendorId ? `[${vendorId}]` : "",
    onsitead_url: url,
  };

  return trackPublisher("publisher.impression", payload);
};

export const trackContentClick = ({
  pageSlug,
  chapters,
  format = "",
  url = "",
  contentId = "",
  positionItem,
  nbItems,
  vendorId = "",
}: ContentPublisherTrackingProps): Publisher => {
  const generalPlacement =
    positionItem == null ? "" : nbItems ? `[${positionItem}-${nbItems}]` : `[${positionItem}]`;

  const chapter1 = chapters?.chapter1 ?? pageSlug;
  const chapter2 = chapters?.chapter2 ?? "";
  const chapter3 = chapters?.chapter3 ?? "";

  const payload: Publisher = {
    onsitead_campaign: `[${chapter1}::${chapter2}::${chapter3}::${pageSlug}]`,
    onsitead_creation: `[${url || "no_url"}]`,
    onsitead_variant: `[${contentId}]`,
    onsitead_format: `[${format}]`,
    onsitead_general_placement: generalPlacement,
    onsitead_advertiser: vendorId ? `[${vendorId}]` : "",
    onsitead_url: url,
  };

  return trackPublisher("publisher.click", payload);
};
